<div class="modal fade" [attr.id]="'modification-modal'" tabindex="-1" role="dialog" [attr.aria-labelledby]="customIdLabel" aria-hidden="true" *ngIf="toShowModal">
  <div class="modal-dialog" role="document">
    <div class="warning-modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="customIdLabel">{{ lextranslate.i18n["ba7dd5f5-b8c1-4c4f-96a4-45b05663d293"] }}</h5>
      </div>
      <div class="modal-body">
        <em class="material-icons icon-warning">warning</em>
        <p>{{ lextranslate.i18n["d74318ea-d3a2-4a91-a19a-88283ec6f896"] }}.</p>
        <p class="font-weight-bold" style="margin: 20px 0;">{{ lextranslate.i18n["19f949f0-3850-4156-ba04-aaf3fd2e9952"]}}?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" data-dismiss="modal" (click)="cancelAction()">{{ lextranslate.i18n["959fd220-ec97-46fd-8218-cd1217e026e4"] }}</button>
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="confirmAction()">{{ lextranslate.i18n["dcf43eb9-086b-4945-84eb-8ea69cdcdfc8"] }}</button>
      </div>
    </div>
  </div>
</div>
